export default __webpack_public_path__ + "static/media/classic01.c4c32330.png";